import { observer } from 'src/utils/mobx-react';
import React, { ChangeEvent, useState } from 'react';
import { useAsObservableSource } from 'mobx-react-lite';
import { CreateMarketFormState } from 'src/domains/sportsbook/trading/view/eventDetails/markets/createMarketModal/CreateMarketForm.state';
import { range } from 'lodash';
import { PossibleMarketsType } from 'src/AppState/sdk/staff';
import { ArrayElement } from './CreateMarketForm.state';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';

function createField(type: string, name: string, onChangeHandler: (e: ChangeEvent<HTMLSelectElement>) => void): JSX.Element {
    if (type === 'double' && name.toLowerCase().includes('handicap')) {
        return (
            <select name={ name } onChange={onChangeHandler} key={name}>
                <option />
                {
                    range(-20, 20).map(i => <option key={ i } value={ i + 0.5 }>{ i + 0.5 }</option>)
                }
            </select>
        );
    }
    if (type === 'double' || type === 'both') {
        return (
            <select name={ name } onChange={onChangeHandler} key={name}>
                <option />
                {
                    range(0, 20).map(i => <option key={ i } value={ i + 0.5 }>{ i + 0.5 }</option>)
                }
            </select>
        );
    } else if (type === 'int') {
        return (
            <select name={ name } onChange={onChangeHandler} key={name}>
                <option />
                {
                    range(0, 20).map(i => <option key={ i } value={ i }>{ i }</option>)
                }
            </select>
        );
    } else {
        return (
            //@ts-expect-error
            <input name={ name } type='text' onChange={onChangeHandler} key={name}/>
        );
    }
}

interface RequiredParametersPropsType {
    options: Record<string, string> | null
    onChange: (e: ChangeEvent<HTMLSelectElement>) => void
}

const RequiredParameters = observer('RequiredParameters', (props: RequiredParametersPropsType) => {
    const options = props.options;

    if (options === null || Object.keys(options).length === 0) {
        return null;
    }

    return (<div className='element hasLabel'>
        <div className='select-wrapper'>
            {
                Object.keys(options).map(key => {
                    const option = options[key];
                    if  (option === undefined) {
                        return null;
                    } else {
                        return createField(option, key, props.onChange);
                    }
                })
            }
        </div>
    </div>);
});


export interface CreateMarketFormPropsType {
    markets: PossibleMarketsType
    eventId: EventId
    onSubmit: (data: {templateId: string, params: ArrayElement<PossibleMarketsType> | null}) => void
}

export const CreateMarketForm = observer('CreateMarketForm', (propsIn: CreateMarketFormPropsType) => {
    const props = useAsObservableSource(propsIn);
    const [state] = useState(() => new CreateMarketFormState(props));

    if (props.markets.length === 0) {
        return (<div className='form'>
            You can&apos;t add any market for this event.
        </div>);
    }

    const baseClassName = 'element empty required hasLabel';
    const templateInputClass = state.templateValidation === null ?
        baseClassName :
        (state.templateValidation === true ? baseClassName + ' valid' :
            baseClassName + ' invalid error');

    return (<div className='form'>
        <div className={templateInputClass}>
            <div className='select-wrapper' data-test='template'>
                <select name='Template' onChange={state.onSelectMarket}>
                    <option value='' />
                    {props.markets.map(market => {
                        const marketIdentifier = market.id ?? market.name;
                        
                        return (
                            <option key={ marketIdentifier} value={ marketIdentifier } >
                                { market.name }
                            </option>);
                    })}
                </select>
                <label>Template</label>
            </div>
            {
                state.templateValidation === false ?
                    <div className='error-message'>
                        <div className='error-message-content'>This field is required.</div>
                    </div> : null
            }
        </div>

        <RequiredParameters options={state.requiredParams} onChange={state.onSelectOption} />
        <div className='buttons'>
            <button type='button' className='btn' data-test='add-market-button' onClick={state.onAddMarket}>Add</button>
        </div>
    </div>);
});
